import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import menuSelect from 'instantsearch.js/es/widgets/menu-select/menu-select';
import searchBox from 'instantsearch.js/es/widgets/search-box/search-box';
import stats from 'instantsearch.js/es/widgets/stats/stats';
import { customInfiniteHits } from './hits';

/**
 * Mets en place la recherche Algolia
 *
 */
const initializeSearch = () => {
    /** @type {HTMLElement} */
    const algoliaData = document.querySelector('#algolia-data');

    const algoliaAppId = algoliaData.dataset.algoliaAppId;
    const algoliaApiKey = algoliaData.dataset.algoliaApiKey;
    const algoliaIndex = algoliaData.dataset.algoliaIndex;
    const countTextSingular = algoliaData.dataset.algoliaCountTextSingular;
    const countTextPlural = algoliaData.dataset.algoliaCountTextPlural;
    const actionUrl = algoliaData.dataset.actionDate;
    const villePlaceholder =
        document.querySelector('#ville').dataset.algoliaPlaceholder;
    const contratPlaceholder =
        document.querySelector('#contrat').dataset.algoliaPlaceholder;
    const searchPlaceholder =
        document.querySelector('#search').dataset.algoliaPlaceholder;

    if (
        typeof algoliaAppId === 'undefined' ||
        typeof algoliaApiKey === 'undefined' ||
        typeof algoliaIndex === 'undefined'
    ) {
        console.error(
            'You must provide the Algolia App ID, API key and index for the search module to work.'
        );
        return;
    }

    const searchClient = algoliasearch(algoliaAppId, algoliaApiKey);

    const search = instantsearch({
        indexName: algoliaIndex,
        searchClient,
    });

    search.addWidgets([
        menuSelect({
            container: '#ville',
            attribute: 'region',
            cssClasses: {
                root: 'topic_list',
                select: ['custom-select'],
            },
            templates: {
                defaultOption: villePlaceholder,
            },
        }),
        menuSelect({
            container: '#contrat',
            attribute: 'contrat',
            cssClasses: {
                root: 'topic_list',
                select: ['custom-select'],
            },
            templates: {
                defaultOption: contratPlaceholder,
            },
        }),
        searchBox({
            container: '#search',
            placeholder: searchPlaceholder,
            autofocus: true,
            showReset: false,
            showSubmit: false,
            cssClasses: {
                root: 'form-group',
                input: 'form-control',
            },
        }),
        customInfiniteHits({
            container: '#hits',
            actionUrl,
            transformItems(items) {
                return items.map((item) => {
                    // On essaye d'effectuer un join() sur un item. Si l'item n'est pas un array,
                    // le join() ne marche pas et l'item garde sa valeur initiale
                    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Optional_chaining#combining_with_the_nullish_coalescing_operator
                    item.ville = item.ville.join?.(', ') ?? item.ville;
                    item.contrat = item.contrat.join?.(', ') ?? item.contrat;
                    item.mobilite = item.mobilite.join?.(', ') ?? item.mobilite;
                    return item;
                });
            },
        }),
        stats({
            container: '#hits-count',
            templates: {
                text: `{{nbHits}} {{#hasManyResults}}${countTextPlural}{{/hasManyResults}}{{#hasOneResult}}${countTextSingular}{{/hasOneResult}}`,
            },
        }),
    ]);

    search.start();
};

document.addEventListener('DOMContentLoaded', () => {
    initializeSearch();
});
